import { type FC } from 'react';
import { Button, type ButtonProps, IconOpenInNewTab } from '@direct-frontend/components';
import { addHttpsProtocol } from '#shared/lib/url';

export type SettingsButtonOpenInSiteProps = Pick<ButtonProps, 'size' | 'color' | 'width' | 'isDisabled'> & {
    url: string | undefined;
    'data-testid'?: string;
};

export const SettingsButtonOpenInSite: FC<SettingsButtonOpenInSiteProps> = ({
    url,
    isDisabled,
    size = 'm',
    color = 'normal',
    width = 'max',
    'data-testid': dataTestId,
}) => {
    const href = url ? addHttpsProtocol(url) : undefined;

    return (
        <Button
            as="a"
            target="_blank"
            size={size}
            color={color}
            width={width}
            iconRight={IconOpenInNewTab}
            href={href}
            isDisabled={isDisabled || !href}
            data-testid={dataTestId}
        >
            Показать на сайте
        </Button>
    );
};
